import { useConfig } from 'domains/config/hooks'
import { useMemo } from 'preact/hooks'
import ComponentContext from './component-context'
import CardMessage from './event/card-message'
import CarouselMessage from './event/carousel-message'
import ChoicePrompt from './event/choice-prompt'
import ConversationSuggestions from './event/conversation-suggestions'
import Divider from './event/divider'
import TimeIndicator from './event/divider/variants/time-indicator'
import Image from './event/image'
import Participant from './event/participant'
import Splash from './event/splash'
import Text from './event/text'
import Translation from './event/translation'
import Upload from './event/upload'
import Video from './event/video'

const eventTypeMapping = {
  message: {
    choice_prompt: ChoicePrompt,
    text: Text,
    image: Image,
    splash: Splash,
    video: Video,
    upload: Upload,
    carousel: CarouselMessage,
    card: CardMessage,
  },
  info: {
    text: Text,
    divider: Divider,
    translation: Translation,
    timeIndicator: TimeIndicator,
  },
  participant: {
    participant: Participant,
  },
  service_data: {
    suggestion: ConversationSuggestions,
  },
}

const ComponentFilter = ({ children }) => {
  const { customComponents } = useConfig()

  const resolvedComponents = useMemo(() => {
    // Calculates a combined component mapping object based on the defaults with
    // user implementation component overrides where required.
    return Object.keys(eventTypeMapping).reduce(
      (acc, key) => {
        acc[key] = {
          ...eventTypeMapping[key],
          ...(customComponents ? customComponents[key] : {}),
        }

        return acc
      },
      { fallback: Text },
    )
  }, [customComponents])

  return (
    <ComponentContext.Provider value={resolvedComponents}>
      {children}
    </ComponentContext.Provider>
  )
}

export default ComponentFilter
